import type { SxProps, Theme } from "@mui/material/styles";
import { BACKGROUND_DARK, MAX_WIDTH, SIDE_PADDING } from "../../theme/consts";

export const getFooterSx = (backgroundColor?: string): SxProps<Theme> => ({
  backgroundColor: backgroundColor ?? BACKGROUND_DARK,
  color: "#979797",
  width: "100%",
});

export const footerContentSx: SxProps<Theme> = {
  maxWidth: MAX_WIDTH,
  width: "100%",
  margin: "0 auto",
  padding: {
    xs: `0 ${SIDE_PADDING.xs} 2rem`,
    md: `0 ${SIDE_PADDING.md} 2rem`,
    xl: `0 ${SIDE_PADDING.xl} 2rem`,
  },
  flexDirection: "column",
  gap: "2rem",
};

export const dividerSx: SxProps<Theme> = {
  borderColor: "gray",
};

export const logoSectionSx: SxProps<Theme> = {
  flexDirection: "column",
  gap: "1rem",
};

export const footerLogoImageSx: SxProps<Theme> = {
  height: "auto",
  maxHeight: { xs: "2.5rem", md: "3rem" },
  width: { xs: "8rem", md: "10rem" },
  display: "block",
  color: "#FFFFFF",
};

export const sloganSx: SxProps<Theme> = {
  fontSize: { xs: "0.875rem", md: "1rem" },
  fontWeight: 300,
  color: "#979797",
  lineHeight: 1.6,
};

export const bottomSectionSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: { xs: "flex-start", md: "center" },
  gap: { xs: "1rem", md: "2rem" },
};

export const copyrightTextSx: SxProps<Theme> = {
  fontSize: { xs: "0.75rem", md: "0.875rem" },
  fontWeight: 400,
  color: "#b0b0b0",
};

export const legalLinksSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
  gap: { xs: "0.5rem", md: "1.5rem" },
};

export const legalLinkSx: SxProps<Theme> = {
  fontSize: { xs: "0.75rem", md: "0.875rem" },
  fontWeight: 400,
  color: "#b0b0b0",
  textDecoration: "none",
  "&:hover": {
    color: "#e5e5e5",
    textDecoration: "underline",
  },
};
